<div class="overflow-x-auto">
  <table
    class="w-full border-collapse rounded-lg overflow-hidden shadow-lg bg-white"
  >
    <thead>
      <tr class="bg-gradient-to-r from-orange-400 to-red-800">
        <th
          *ngFor="let column of columns"
          class="text-white p-3 text-left font-poppins font-semibold"
        >
          {{ column.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of displayData; let i = index"
        class="even:bg-gray-50 hover:bg-orange-50"
      >
        <td
          *ngFor="let column of columns"
          class="p-3 border-b text-sm font-poppins text-gray-700"
        >
          <span *ngIf="!column.renderHtml">{{ formatValue(column, row) }}</span>
          <span
            *ngIf="column.renderHtml"
            [innerHTML]="getFormattedValue(column, row)"
          ></span>
        </td>
      </tr>
      <tr *ngIf="!hasData">
        <td
          [attr.colspan]="columns.length"
          class="p-3 border-b text-sm font-poppins text-gray-700 text-center"
        >
          No data available
        </td>
      </tr>
    </tbody>
  </table>
</div>
